export { default as translations } from './translations.json';

export const EXTENSION_STATUSES = ['pending', 'accepted', 'rejected'];

/**
 * Get extension request from transaction.
 * @param {Object|null} transaction
 * @returns {Object|null}
 */
export const getExtensionRequest = (transaction) =>
  transaction?.attributes?.metadata?.extensionRequest || null;

export const hasExtensionPending = (transaction) =>
  getExtensionRequest(transaction)?.status === 'pending';
